import Constants from "../../config/Constants";

function ConsoleLog(data) {
    if (Constants.DEBUG_MODE) {
        console.log(data)
    }
}

export default ConsoleLog;